import { postLogout } from "api/generated/authentication/authentication";

function orgLogout() {
    postLogout().then((res) => {
        window.location.assign(res.headers["location"] as string);
    });
}

export { orgLogout };
